import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturedGrid from './components/FeaturedGrid';
import CategoryGrid from './components/CategoryGrid';
import TrustStats from './components/TrustStats';
import ArticlePreview from './components/ArticlePreview';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssspreadsheet.rest';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'CSSBuy Spreadsheet Directory',
  url: siteUrl,
  description: 'The largest free CSSBuy spreadsheet directory with thousands of verified products, trusted sellers, QC photos, and daily updated fashion finds across 14 categories.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://kaspreadsheet.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'CSSBuy Spreadsheet Directory',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png',
  description: 'The largest free CSSBuy spreadsheet directory — discover verified products, trusted sellers, and daily updated fashion finds.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 relative overflow-hidden">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      {/* Global background glow orbs */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" aria-hidden="true">
        <div className="bg-orb bg-orb-primary w-[600px] h-[600px] -top-[200px] -left-[100px] animate-orb-float"></div>
        <div className="bg-orb bg-orb-accent w-[500px] h-[500px] top-[40%] -right-[150px] animate-orb-float-slow"></div>
        <div className="bg-orb bg-orb-warm w-[400px] h-[400px] bottom-[10%] left-[20%] animate-orb-float" style={{ animationDelay: '-6s' }}></div>
        <div className="bg-orb bg-orb-primary w-[350px] h-[350px] top-[70%] right-[30%] animate-orb-float-slow" style={{ animationDelay: '-4s' }}></div>
        {/* Subtle noise overlay */}
        <div className="bg-noise opacity-[0.25]"></div>
      </div>

      <div className="relative z-10">
        <Navbar />
        <Hero />
        <FeaturedGrid />
        <CategoryGrid />
        <TrustStats />
        <ArticlePreview />
        <CTASection />
        <Footer />
      </div>
    </main>
  );
}